export default {
	data() {
    return {
      loads: [],
      loadExtraData: []
    };
	},
  methods: {
    ShowEntityCreate(name) {
      let entity = this.$store.state.schema.all.find(f => name == f.name)
      return entity.actions.create;
    },
    ShowEntityEdit(name) {
      let entity = this.$store.state.schema.all.find(f => name == f.name)
      return entity.actions.edit;
    },
    ShowEntityDelete(name) {
      let entity = this.$store.state.schema.all.find(f => name == f.name)
      return entity.actions.delete;
    },
    ShowEntityView(name){
      let entity = this.$store.state.schema.all.find(f => name == f.name)
      return entity.actions.view;
    }
  },
	created() {
		this.loads = _.get(ENV.ENTITIES, `${this.entityName}.index.add`, [])
      .filter(x => x.load)
      .map(x => x.load);
  }
}
